<template>
  <form v-show="addMetricForm">
    <v-layout wrap row class="pa-4 white-bg elevation-2 rounded-3">
      <v-flex xs12 sm6>
        <v-text-field
          v-model="metric.name"
          label="New Metric name"
          @change="recordChange()"
          box
        ></v-text-field>

        <h3>Metric Type</h3>
        <v-radio-group class="mt-1" v-model="metric.type" mandatory @change="recordChange()" :disabled="!newMetric">
          <v-radio
            color="secondary"
            label="Case Property"
            value="Case Property"
          ></v-radio>
          <v-radio
            color="secondary"
            label="State Transition"
            value="State Transition"
          ></v-radio>
          <v-radio
            color="secondary"
            label="Bucket"
            value="Bucket"
          ></v-radio>
        </v-radio-group>

        <v-select
          v-model="metric.caseTypeId"
          :items="caseTypes"
          item-text="name"
          item-value="id"
          box
          label="Select a case template"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>

        <h3 v-show="showStates && metric.caseTypeId">Statuses to include</h3>
        <v-checkbox :disabled="!newMetric" v-show="showStates && metric.caseTypeId" color="secondary" :label=state.state class="ma-0" v-model="state.selected" v-on:change="selectecState(state)" v-for="(state,  index) in caseTypeStates" :key="index"></v-checkbox>

        <v-select
          v-show="showBuckets && metric.caseTypeId"
          v-model="metric.bucketId"
          :items="buckets"
          item-text="name"
          item-value="id"
          box
          label="Select a bucket"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>
      
        <v-select
          v-show="showFields && metric.caseTypeId"
          v-model="metric.propertyName"
          :items="metricFields"
          box
          label="Select a field"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>

        <v-select
          v-show="showFunctions && metric.bucketId"
          v-model="metric.functionName"
          :items="availableFunctions"
          box
          label="Select a function to apply to the contents of the bucket"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>  

        <v-select
          v-show="showBaseMetrics && metric.bucketId && metric.functionName"
          v-model="metric.baseMetricId"
          :items="baseMetrics"
          item-text="name"
          item-value="id"
          box
          label="Select a base metric"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>        

        <v-select
          v-show="showBaseMetrics && metric.bucketId && metric.baseMetricId"
          v-model="metric.groupBy"
          :items="groupByFields"
          box
          label="Select a field to group measurements by"
          dense
          append-icon="keyboard_arrow_down"
          @change="recordChange()"
          :disabled="!newMetric"          
        >
        </v-select>        
      


      </v-flex>
      <v-flex xs12 v-if="newMetric">
        <v-btn class="ml-0" color="success" @click="createMetric()"
          >Confirm Metric</v-btn
        >
        <v-btn color="error" v-on:click="cancelCreateMetric()">Cancel</v-btn>
      </v-flex>
      <v-flex xs12 v-else>
        <v-btn @click="updateMetric" :disabled="!metricUpdated" class="ml-0" color="success">Save Changes</v-btn>
      </v-flex>

    </v-layout>
  </form>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "MetricForm",
  methods: {
    recordChange() {
      this.metricUpdated = true
    },
    async updateMetric() {
      await this.$store.dispatch('updateMetric', this.metric)
    },
    async createMetric() {
      if (this.metric.type==="State Transition") {
        this.metric.intermediateStateIds = this.caseTypeStates.filter(cts => cts.selected).map(cts => cts.id)
      }
      await this.$store.dispatch('createMetric', this.metric)
      this.$emit("metric-added")
    },
    cancelCreateMetric() {
      this.$emit("metric-cancelled")
    },
    selectecState(state) {
      console.log("selected", {state})
    },
    initialiseCaseTypeStates() {
      const selectedCaseType = this.caseTypes.find(ct => ct.id === this.metric.caseTypeId)
      const states =  selectedCaseType ? selectedCaseType.statuses : []

      this.caseTypeStates = states.map(s => ({id: s.id, state: s.state, selected: this.metric.intermediateStateIds && this.metric.intermediateStateIds.includes(s.id)}))
    },
    setFlags() {
      switch (this.metric.type) {
        case "Case Property":
          this.showFields = true;
          this.showBuckets = false;
          this.showStates = false;
          this.showBaseMetrics = false;
          this.showFunctions = false;
          break;
        case "State Transition":
          this.showFields = false;
          this.showBuckets = false;
          this.showStates = true;
          this.showBaseMetrics = false;
          this.showFunctions = false;
          break;
        case "Bucket":
          this.showFields = false;
          this.showBuckets = true;
          this.showStates = false;
          this.showBaseMetrics = true;
          this.showFunctions = true;
          break;
      
        default:
          break;
      }
    }
  },
  computed: {
    ...mapState({
      caseTypes: (state) => state.caseTypes.all,
      metrics: (state) => state.metrics.all,
    }),
    newMetric() {
      return !(this.metric && this.metric.id)
    },
    selectedCaseTypeId() {
      return this.metric.caseTypeId
    },
    selectedType() {
      return this.metric.type
    },
    buckets() {
      const selectedCaseType = this.caseTypes.find(ct => ct.id === this.metric.caseTypeId)
      return selectedCaseType ? selectedCaseType.buckets : []
    },
    baseMetrics() {
      return this.metrics.filter(m => m.caseTypeId === this.metric.caseTypeId && (m.type==='Case Property' || m.type==="State Transition"))
    },
    groupByFields() {
      let fields = ['None', 'current_state']
      
      if (this.metric.caseTypeId) {
        const selectedCaseType = this.caseTypes.find(ct => ct.id === this.metric.caseTypeId)
        if (selectedCaseType) {
          for (const fieldset of selectedCaseType.currentSchema.fieldsets) {
            for (const field of fieldset.fields) {
              if (field.type === "string") {
                fields.push(field.name)
              }
            }
          }
        }
      }
      return fields
    },
    metricFields() {
      let fields = []
      
      if (this.metric.caseTypeId) {
        const selectedCaseType = this.caseTypes.find(ct => ct.id === this.metric.caseTypeId)
        if (selectedCaseType) {
          for (const fieldset of selectedCaseType.currentSchema.fieldsets) {
            for (const field of fieldset.fields) {
              if (field.type === "number") {
                fields.push(field.name)
              }
            }
          }
        }
      }
      return fields
    }    
  },  
  data: () => {
    return {
      availableFunctions: ['avg', 'count', 'median', 'sum'],
      showDeleteDialog: false,
      addMetricButton: true,
      showBuckets: false,
      showFields: true,
      showBaseMetrics: false,
      showStates: false,
      showFunctions: false,
      caseTypeStates: [],
      metricUpdated: false
    };
  },
  created() {
    this.setFlags();
    this.initialiseCaseTypeStates()
  },
  watch: {
    selectedCaseTypeId() {
      this.initialiseCaseTypeStates()
    },
    selectedType() {
      this.setFlags();
    }
  },
  props: {
    addMetricForm: {
      type: Boolean,
      required: true
    },
    metric: {
      type: Object,
      required: true
    }
  }
};
</script>